export default __webpack_public_path__ + "static/media/My_car_website_images-5_3.fe9b455b.jpg";